import { render, staticRenderFns } from "./EducationQuestions.vue?vue&type=template&id=5bf7f6c8&scoped=true&"
import script from "./EducationQuestions.vue?vue&type=script&lang=js&"
export * from "./EducationQuestions.vue?vue&type=script&lang=js&"
import style0 from "./EducationQuestions.vue?vue&type=style&index=0&id=5bf7f6c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7f6c8",
  null
  
)

export default component.exports